import Tippy, { TippyProps } from '@tippyjs/react';
import { sticky } from 'tippy.js';
import React from 'react';
// import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/shift-away.css';

export const Tooltip: React.FC<TippyProps> = props => {
    return <Tippy animation={'shift-away'} {...props}></Tippy>;
};

export const TooltipDropdownBase: React.FC<TippyProps> = (props) => (
    <Tooltip
        arrow={false}
        placement="bottom"
        plugins={[sticky]}
        trigger="click"
        interactive={true}
        offset={[0, 2]}
        {...props}
    />
);
